import type { IRebalancedPortfolioFilterInput } from 'generated/graphql.tsx';
import {
  type AllocationConstraintsInput,
  type AllocationConstraintsOutput,
  schema as allocationConstraintsSchema,
} from '../allocationConstraints/AllocationConstraintsStep.validation.ts';
import {
  type RiskBudgetInput,
  type RiskBudgetOutput,
  riskBudgetSchema,
} from '../assumptionsAndOutlook/AssumptionsAndOutlook.validation.tsx';
import {
  type DescriptionStepInput,
  type DescriptionStepOutput,
  schema as descriptionSchema,
} from '../description/DescriptionStep.validation.ts';
import {
  type ObjectivesStepInput,
  type ObjectivesStepOutput,
  createSchema as createObjectivesSchema,
} from '../objective/ObjectivesStep.validation.ts';
import {
  type PortfolioConstraintsStepOutput,
  type PortfolioLevelConstraintsStepInput,
  createSchema as createPortfolioConstraintSchema,
} from '../portfolioConstraints/PortfolioConstraintsStep.validation.ts';
import { secondaryConstraintQuantityValues } from '../portfolioConstraints/PortfolioSecondaryConstraint.validation.ts';
import * as yup from 'yup';

export interface AssetScreenerStepOutput {
  filters: IRebalancedPortfolioFilterInput[];
}

export interface AssetScreenerStepInput {
  filters: IRebalancedPortfolioFilterInput[];
}

export const assetScreenerStepSchema = yup.object({
  filters: yup.array(yup.object().required()),
});

export type PortfolioDefinitionWithAssetScreenerOutputFields = DescriptionStepOutput &
  ObjectivesStepOutput<false> &
  PortfolioConstraintsStepOutput &
  AssetScreenerStepOutput &
  AllocationConstraintsOutput &
  RiskBudgetOutput;

export type PortfolioDefinitionWithAssetScreenerInputFields = DescriptionStepInput &
  ObjectivesStepInput<false> &
  PortfolioLevelConstraintsStepInput &
  AllocationConstraintsInput &
  AssetScreenerStepInput &
  RiskBudgetInput;

export const schema = descriptionSchema
  .concat(createObjectivesSchema(false))
  .concat(createPortfolioConstraintSchema(secondaryConstraintQuantityValues))
  .concat(assetScreenerStepSchema)
  .concat(allocationConstraintsSchema)
  .concat(riskBudgetSchema);
